import { Heading } from "@/common/components";

const ProductDetails = ({ ownerData, labels }) => {
  const { planId, recordkeeperRecordkeepingSystem, product } = ownerData;

  return (
    <>
      <Heading
        text={labels?.ownerInquiry?.productDetails}
        wrapperClassNames="h4 border-bottom-1 pb-1 mt-5"
        title={false}
      />
      <div className="d-flex flex-column flex-md-row justify-content-between mt-3 column-gap-5">
        <div className="d-flex flex-column flex-1">
          <div className="division">
            <span className="left">
              {labels?.ownerInquiry?.productDetailsProductName}
            </span>
            <span className="right">{product?.name ? product.name : "-"}</span>
          </div>
          <div className="division">
            <span className="left">
              {labels?.ownerInquiry?.productDetailsPlanId}
              {":"}
            </span>
            <span className="right">{planId ? planId : "-"}</span>
          </div>
        </div>
        <div className="d-flex flex-column flex-1">
          <div className="division">
            <span className="left">
              {labels?.ownerInquiry?.productDetailsRecordKeeper}
            </span>
            <span className="right">
              {recordkeeperRecordkeepingSystem?.recordkeeperName
                ? recordkeeperRecordkeepingSystem?.recordkeeperName
                : "-"}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetails;
